import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";

const REACT_APP_MANAGE_USERS = process.env.REACT_APP_MANAGE_USERS;
const radio_id = window.localStorage.getItem("radio_id");

axios.interceptors.request.use(
  (config) => {
    const accessToken = window.localStorage.getItem("access_token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (radio_id) {
      config.headers["radio-id"] = radio_id;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status && error.response?.status === 401) {
      localStorage.removeItem("userData");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.setItem("isAuth", false);
      window.location.assign(`/admin/login`);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export const handleLogin = (email, password, remember_me) => (dispatch) => {
  axios
    .post(`${REACT_APP_MANAGE_USERS}/auth/login`, {
      email,
      password,
      remember_me,
      product_id: radio_id,
    })
    .then((res) => {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data,
      });
      localStorage.setItem("userData", JSON.stringify(res.data.user));
      localStorage.setItem("access_token", res.data.access_token);
      localStorage.setItem("refresh_token", res.data.refresh_token);
      localStorage.setItem("isAuth", true);
    })
    .catch((err) => {
      if (err.response.data) {
        dispatch({
          type: "LOGIN_FAIL",
          payload: err.response.data,
        });
        setTimeout(() => {
          dispatch({
            type: "LOGIN_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const handleLogout = () => (dispatch) => {
  localStorage.removeItem("userData");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.setItem("isAuth", false);
  window.location.assign(`/admin/login`);
};
export const getAuthUser = () => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/auth/authguard`)
    .then((res) => {
      dispatch({
        type: "GET_AUTH_USER_SUCCESS",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      console.log("errGetAuth", err);
    });
};
export const getUserByEmail = (email) => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/users/email/${email}`)
    .then((res) => {
      dispatch({
        type: "GET_USER__BY_EMAIL_SUCCESS",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ERROR_GET_USER__BY_EMAIL_SUCCESS",
          payload: err.response.data,
        });
        setTimeout(() => {
          dispatch({
            type: "ERROR_GET_USER__BY_EMAIL_SUCCESS",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getUserByEmailByCompany = (email, company_id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/users/email/${email}/company/${company_id}`)
    .then((res) => {
      dispatch({
        type: "GET_USER__BY_EMAIL_SUCCESS_COMPANY",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ERROR_GET_USER__BY_EMAIL_FAILED_COMPANY",
          payload: err.response.data,
        });
        setTimeout(() => {
          dispatch({
            type: "ERROR_GET_USER__BY_EMAIL_FAILED_COMPANY",
            payload: null,
          });
        }, 3000);
      }
    });
};

export const forgetPassword = (info, func) => (dispatch) => {
  axios
    .post(`${REACT_APP_MANAGE_USERS}/auth/forgetpassword`, info)
    .then(async (res) => {
      await handleSuccessOne(res.data.message, () => {
        window.location.assign(`/admin/login`);
      });
      await dispatch({
        type: "FORGET_PASSWORD",
      });
      await func();
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "FORGET_PASSWORD_FAIL",
          payload: err.response.data.data,
        });
        setTimeout(() => {
          dispatch({
            type: "FORGET_PASSWORD_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const resetPassword = (info, token, func) => (dispatch) => {
  axios
    .post(`${REACT_APP_MANAGE_USERS}/auth/resetpassword/${token}`, info)
    .then((res) => {
      dispatch({
        type: "RESET_PASSWORD",
      });
      func();
      handleSuccessOne(res.data.message);
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "RESET_PASSWORD_FAIL",
          payload: err.response.data.data,
        });
        setTimeout(() => {
          dispatch({
            type: "RESET_PASSWORD_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const changePassword = (user_id, data, func) => (dispatch) => {
  axios
    .patch(`${REACT_APP_MANAGE_USERS}/users/${user_id}/changepassword`, data)
    .then((res) => {
      dispatch({
        type: "CHANGE_PASSWORD_SUCCESS",
      });
      func();
      handleSuccessOne(res.data.message);
    })
    .catch((err) => {
      if (err.response.status === 422) {
        dispatch({
          type: "CHANGE_PASSWORD_FAIL",
          payload: err.response.data.data,
        });
        setTimeout(() => {
          dispatch({
            type: "CHANGE_PASSWORD_FAIL",
            payload: null,
          });
        }, 3000);
      } else {
        dispatch({
          type: "CHANGE_PASSWORD_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "CHANGE_PASSWORD_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const changeEmail = (user_id, data, func) => (dispatch) => {
  axios
    .patch(`${REACT_APP_MANAGE_USERS}/users/${user_id}/changeemail`, data)
    .then((res) => {
      dispatch({
        type: "UPDATE_EMAIL_SUCCESS",
      });
      handleSuccessOne(res.data.message);
      dispatch(getAuthUser());
      func();
    })
    .catch((err) => {
      if (err.response.status === 422) {
        dispatch({
          type: "UPDATE_EMAIL_FAIL",
          payload: err.response.data.data,
        });
        setTimeout(() => {
          dispatch({
            type: "UPDATE_EMAIL_FAIL",
            payload: null,
          });
        }, 3000);
      } else {
        dispatch({
          type: "UPDATE_EMAIL_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "UPDATE_EMAIL_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const updateProfile = (info, func) => (dispatch) => {
  const data = new FormData();
  data.append("_method", "Put");
  data.append("user_id", info.user_id);
  data.append("user_name", info.user_name);
  data.append("first_name", info.first_name);
  data.append("last_name", info.last_name);
  info.date_of_birth && data.append("date_of_birth", info.date_of_birth);
  info.place_of_birth && data.append("place_of_birth", info.place_of_birth);
  info.mobile && data.append("mobile", info.mobile);
  info.gender_id && data.append("gender_id", info.gender_id);
  info.countrie_id && data.append("countrie_id", info.countrie_id);
  info.state_id && data.append("state_id", info.state_id);
  info.city_id && data.append("city_id", info.city_id);
  info.region_id && data.append("region_id", info.region_id);
  info.zip_code_id && data.append("zip_code_id", info.zip_code_id);
  info.address && data.append("address", info.address);
  info.avatar && data.append("avatar", info.avatar);

  axios
    .post(`${REACT_APP_MANAGE_USERS}/users/${info.user_id}`, data)
    .then((response) => {
      dispatch({
        type: "EDIT_USER_SUCCESS",
      });
      handleSuccessOne(response.data.message);
      dispatch(getAuthUser());
      func();
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_USER_FAIL",
          payload: err.response.data?.data,
        });
        const timeoutId = setTimeout(() => {
          dispatch({
            type: "EDIT_USER_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const acceptAccount = (user_id, info, func) => (dispatch) => {
  axios
    .patch(`${REACT_APP_MANAGE_USERS}/users/${user_id}/acceptregister`, info)
    .then((res) => {
      dispatch({
        type: "ACCEPT_ACCOUNT_SUCCESS",
      });
      handleSuccessOne(res.data.message, () => {
        func();
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ACCEPT_ACCOUNT_FAIL",
          payload: err.response.data,
        });
        setTimeout(() => {
          dispatch({
            type: "ACCEPT_ACCOUNT_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};

export const verifyEmail = (token) => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/auth/verify/email/${token}`)
    .then((res) => {
      dispatch({
        type: "VERIFY_SUCCESS",
        payload: res.data.message,
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "VERIFY_SUCCESS",
          payload: err.response.data.message,
        });
      }
    });
};

export const attachUser =
  (user_id, product_id, role_id, refresh) => (dispatch) => {
    axios
      .post(`${REACT_APP_MANAGE_USERS}/users/product/add/${user_id}`, {
        product_id,
        role_id,
      })
      .then((res) => {
        dispatch(get_user_by_company_not_affected_to_product());
        refresh();
        handleSuccessOne(res.data.message);
      })
      .catch((err) => {
        handleErrorOne(err?.response?.data?.message);
      });
  };
export const detachUser = (user_id, refresh) => (dispatch) => {
  axios
    .post(`${REACT_APP_MANAGE_USERS}/users/product/dettach/${user_id}`)
    .then((res) => {
      refresh();
      handleSuccessOne(res.data.data);
      dispatch(get_user_by_company_not_affected_to_product());
    })
    .catch((err) => {
      handleErrorOne(err?.response?.data?.message);
    });
};

export const get_user_by_company_not_affected_to_product = () => (dispatch) => {
  axios
    .get(`${REACT_APP_MANAGE_USERS}/users`, {
      params: {
        per_page: 9999,
      },
    })
    .then((res) => {
      const filtredUsers = res.data.data.data.data.filter(
        (el) =>
          !el.user_teams.some(
            (role) => role.team.product_id === Number(radio_id)
          ) &&
          !el.is_customer &&
          el.id !== 1
      );
      dispatch({
        type: "GET_USERS_BY_COMPANY_NOT_AFFECTED_TO_PRODUCT",
        payload: filtredUsers,
      });
    });
};
